<template>
<div>
  <div class="wh7footer" :class="{ ie: isie }" >
    <div
      style="
        display: inline-block
        width: 667px;
        margin: 0 auto;
        letter-spacing: 0.5px;
        padding-top: 10px;
      "
    >
      <a
        style="
          font-size: 12px;
          display: block;
          width: 80px;
          margin: 0 auto;
          color: #416ae1;
          margin-bottom:4px
        "
        active-class="nosee"
        href="https://www.wenhua.com.cn/"
        target="_blank"
        >文华财经官网</a
      >

      <div>© 上海文华财经资讯股份有限公司<span v-html="'&nbsp;&nbsp;&nbsp;'" style="padding:0"></span>ICP证号：沪B2-20110035</div>
    </div>
    <a
      href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008976"
      target="_blank"
      style="display: inline-block;margin-left: 15px;position:relative;top:2px"
      ><img src="../../../../assets/images/anq.png"
    /></a>
  </div>
</div>
  
</template>

<script>
import ResTxt from '@/ResData/ResTxt'
export default {
  data() {
    return {
      isie: false,
      // showtime:true,
    };
  },
  components: {
    ResTxt
  },
  // watch: {
  // // $route(to, from) {

  // // }, //路由轮播
  // $route: {
  //         handler: function(to, from){
  //           if(to.name=='buy'){
  //             this.showtime=false
  //           }
  //           else{
  //             this.showtime=true
  //           }
  //         },
  //         immediate: true
  //     },
  // },
  created() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isie = true;
    }
  },
};
</script>

<style>
.wh7footer {
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 64px;

  margin: 0 auto;
  background-color: #14204a;
  color: #e8e9ed;
  font-size: 12px;
  line-height: 20px;
}
.ie {
  font-size: 15px;
}
</style>